module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "theme-block"
  }, [(_vm.title) ? _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "data",
    attrs: {
      "element-loading-text": _vm.$t('themeLegalFormLoadingText'),
      "model": _vm.data,
      "id": "updateForm",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.data.text), function(item, id) {
    return _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "error": _vm.errors.has(item.label) ? _vm.errors.first(item.label) : '',
        "label": _vm.$t(item.label),
        "label-width": _vm.labelWidth,
        "show-message": _vm.errors.has(item.label)
      }
    }, [(_vm.isText(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": item.label,
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": "text"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTextarea(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Textarea-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": item.label,
        "placeholder": _vm.$t(item.placeholder) || '',
        "rows": 20,
        "type": "textarea"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "btn-display-end",
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.saving || _vm.errors.any(),
      "loading": _vm.saving,
      "data-qa": "Content-ThemeForm-Button-Save",
      "native-type": "submit",
      "type": "warning"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('themeLegalButtonSaveText')) + "\n      ")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d06cec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeLegal/ThemeLegal.vue
// module id = 969
// module chunks = 3